<template>
  <div id="app">
      <div v-if="showReloadIcon"
        class="reload-icon"
        :class="animation ? 'reload-icon--animation' : ''"
      >
        <font-awesome-icon icon="sync-alt" />
      </div>
      <NotificationService/>
      <DesktopLayout v-if="!$breakpoint.mdAndDown" >
        <router-view />
      </DesktopLayout>
      <MobileLayout
        v-if="$breakpoint.mdAndDown" >
        <router-view />
      </MobileLayout>
    <IsLoadingPage />
    <!-- <ModalsWrapper v-if="user.uid"/> -->
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import IsLoadingPage from './template/IsLoadingPage.vue';
import MobileLayout from './template/MobileLayout.vue';
import DesktopLayout from './template/DesktopLayout.vue';
import NotificationService from './components/Notification.vue';
// import ModalsWrapper from './components/actions-modals/ModalsWrapper.vue';

export default {
  components: {
    IsLoadingPage,
    DesktopLayout,
    MobileLayout,
    NotificationService,
    // ModalsWrapper,
  },
  data() {
    return {
      showReloadIcon: false,
      animation: false,
    };
  },
  methods: {
    ...mapActions({
      getUser: 'userStore/getUser',
      loadDaysLogs: 'habitsStore/loadDaysLogs',
      setOnlineStatus: 'applicationStore/setOnlineStatus',
    }),
    onRefresh() {
      window.location.reload();
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.userStore.user,
      nick: (state) => state.userStore.nick,
    }),
  },
  async mounted() {
    this.setOnlineStatus(navigator.onLine);
    window.addEventListener('online', () => {
      this.setOnlineStatus(true);
    }, false);
    window.addEventListener('offline', () => {
      this.setOnlineStatus(false);
    }, false);
    await this.getUser();
    window.addEventListener('touchstart', (e) => {
      this.startY = e.touches[0].clientY;
    });
    window.addEventListener('touchmove', (e) => {
      const endY = e.changedTouches[0].clientY;
      const scrollCurrent = window.scrollY;
      const showScroll = (endY - this.startY > 250) && (scrollCurrent < 100);
      if (showScroll) {
        this.showReloadIcon = true;
      }
    });
    window.addEventListener('touchend', (e) => {
      const endY = e.changedTouches[0].clientY;
      const scrollCurrent = window.scrollY;

      if ((endY - this.startY > 500) && (scrollCurrent < 100)) {
        this.animation = true;
        setTimeout(() => {
          this.onRefresh();
        }, 1500);
      } else {
        this.showReloadIcon = false;
      }
    });
  },
};

</script>
<style lang="scss">
body {
  background: $background-color;
  margin: 0;
  color: $font-dark-color;
}
html {
  background: $background-color;
  color: $font-light-color;
}

#app {
  font-family: Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: $font-light-color;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.app-header {
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 28px;
  line-height: 32px;
  color: #1B1D28;
  margin: 30px 20px;
}
.b-numberinput {
  width:45px;
  margin: 0!important;
}
.icon-in-input {
  input {
    border-radius: 12px;
  }
  .icon {
    background: $background-brand-color;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
  }
}
.display-flex {
  display: flex;
}
.flex-align-item-center {
  align-items: center;
}
.flex-justify-contety-center {
  justify-content: center;
}
.flex-justify-contety-space-between {
  justify-content: space-between;
}
#feedbackfin__container {
  width: 95vw!important;
}
.reload-button {
  position: absolute;
  top: 15px;
  left: 15px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  border: 1px black solid;
  background-size: cover;
  background-color: #1B263B;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 15px;
  z-index: 999;
}
.reload-icon {
  position: absolute;
  top: 15px;
  left: 15px;
  width: 30px;
  height: 30px;
  border-radius: 100px;
  border: 1px black solid;
  background-size: cover;
  background-color: #1B263B;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 15px;
  z-index: 999;
  &--animation {
    svg {
      animation: reload 1s linear infinite;
    }
  }
  @keyframes reload {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
